import { render } from "./assignAgency.vue?vue&type=template&id=30fe36da"
import script from "./assignAgency.vue?vue&type=script&lang=js"
export * from "./assignAgency.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__